import React from 'react'
import './Hero.css'
import ShopCategory from '../../Pages/ShopCategory'

const Hero = () => {
  return (
    <div className='hero' >
      <h1>Most Selling</h1>
      <hr />
        <ShopCategory category="home" />
    </div>
  )
}

export default Hero